import Layout from '@/page/index/'
import urlSettings from '@/config/url-settings.js';

let wyFlag = false;
if(urlSettings.VUE_APP_PLATFORM == 'hpss'){
  wyFlag = false;
}else{
  wyFlag = true;
}
// let origin = window.location.hostname;


// if(origin.indexOf('hre')>-1){
//   wyFlag = false;
// }else{
//   wyFlag = true;
// }

export default [{
  path: '/login',
  name: '登录页',
  component: () =>
  wyFlag?import( /* webpackChunkName: "page" */ '@/page/wy-login/index'):import( /* webpackChunkName: "page" */ '@/page/login/index'),
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
},
  {
    path: '/silent-login',
    name: '加载中',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/wy-login/selintlogin'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/lock',
    name: '锁屏页',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/lock/index'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/404',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/404'),
    name: '404',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }

  },
  {
    path: '/403',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/403'),
    name: '403',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/500',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/500'),
    name: '500',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/',
    name: '主页',
    redirect: '/wel'
  },
  {
    path: '/myiframe',
    component: Layout,
    redirect: '/myiframe',
    children: [{
      path: ":routerPath",
      name: 'iframe',
      component: () =>
        import( /* webpackChunkName: "page" */ '@/components/iframe/main'),
      props: true
    }]

  },
  {
    path: '*',
    redirect: '/404'
  }
]
